import { Component, OnInit, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { CustomTranslation, CustomVocabulary, SystemTranslation } from 'app/infrastructure/model/classes/resource.class';
import { AlertService, GrowlType } from 'app/infrastructure/services/alert.service';
import { LoaderService } from 'app/infrastructure/services/loader.service';
import { SxTranslationService } from 'app/infrastructure/services/translation-service.service';

@Component({
    templateUrl: 'detail.resources.component.html',
    styleUrls: ['detail.resources.component.css'],
})

export class DetailResourcesComponent implements OnInit {

  codOrganization: string;
  codSubscription: string;
  codChannel: string;
  //codProduct: string;
  id: string;

  languages: any[];
  vocabulary: any;

  errors: any = [];
  isCustom: boolean;
  isNew: boolean;
  isView: boolean;

  auditInfo: boolean = false;

  constructor(
      private router: Router,
      private aRoute: ActivatedRoute,
      public loader: LoaderService,
      private alertService: AlertService,
      private sxTranslationService: SxTranslationService,
      private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.aRoute.data.subscribe((data: Params) => {
      if (data.isCustom) {
        this.isCustom = data.isCustom;
      }

      if (data.isNew) {
        this.isNew = data.isNew;
      }

      if (data.isView) {
        this.isView = data.isView;
      }
    });

    this.aRoute.params.subscribe((params: Params) => {
      this.codOrganization = params['codorganizacion'];
      this.codSubscription = params['codsistema'];
      this.codChannel = params['codnegocio'];
      //this.codProduct = params['codproducto'];

      if (params['idResource']) {
        this.id = params['idResource'];
      }
    });

    this.sxTranslationService.getAllLanguages()
      .then(response => {
        this.languages = response.result;

        if (this.isNew) {
          //New custom
          let voc = new CustomVocabulary();
  
          voc.organizationCode = this.codOrganization;
          voc.systemCode = this.codSubscription;
          voc.channelCode = this.codChannel;
          //voc.productCode = this.codProduct;

          voc.customTranslations = [];

          this.languages.forEach(element => {
            let tras = new CustomTranslation();
            tras.languageId = element.id;
            tras.culture = element.description;

            voc.customTranslations.push(tras);
          });

          voc.customTranslations = voc.customTranslations.sort((a, b) => a.culture.localeCompare(b.culture));
  
          this.vocabulary = voc;
        }
        else if (this.isCustom) {
          //Edit custom
          this.sxTranslationService.getCustomVocabulary(this.id)
            .then(response => {
              var voc = response;

              this.languages.forEach(element => {
                if (!voc.customTranslations.find(e => e.languageId == element.id)) {
                  let tras = new CustomTranslation();
                  tras.languageId = element.id;
                  tras.culture = element.description;
      
                  voc.customTranslations.push(tras);
                }
              });

              for (let index = voc.customTranslations.length - 1; index >= 0; index--) {
                const element = voc.customTranslations[index];
        
                if (!this.languages.find(e => e.id == element.languageId)) 
                  voc.customTranslations.splice(index, 1);
              }

              voc.customTranslations = voc.customTranslations.sort((a, b) => a.culture.localeCompare(b.culture));

              this.vocabulary = voc;
            });
        } 
        else {
          //Edit system
          this.sxTranslationService.getSystemVocabulary(this.id)
            .then(response => {
              var voc = response;

              this.languages.forEach(element => {
                if (!voc.systemTranslations.find(e => e.languageId == element.id)) {
                  let tras = new SystemTranslation();
                  tras.languageId = element.id;
                  tras.culture = element.description;
                  tras.isSystem = element.isSystem;
      
                  voc.systemTranslations.push(tras);
                }
              });

              for (let index = voc.systemTranslations.length - 1; index >= 0; index--) {
                const element = voc.systemTranslations[index];
        
                if (!this.languages.find(e => e.id == element.languageId)) 
                  voc.systemTranslations.splice(index, 1);
              }

              voc.systemTranslations = voc.systemTranslations.sort((a, b) => a.culture.localeCompare(b.culture));

              this.vocabulary = voc;
            });
        }
      });
  }

  save() {
    if (this.validar()) {
      
      if (this.isCustom) {
        for (let index = this.vocabulary.customTranslations.length - 1; index >= 0; index--) {
          const element = this.vocabulary.customTranslations[index];
  
          if (!element.translationText) 
            this.vocabulary.customTranslations.splice(index, 1);
          else
            element.translationText = this.sanitizer.sanitize(SecurityContext.HTML, element.translationText);
        }
      } else {
        for (let index = this.vocabulary.systemTranslations.length - 1; index >= 0; index--) {
          const element = this.vocabulary.systemTranslations[index];
  
          if (!element.translationText) 
            this.vocabulary.systemTranslations.splice(index, 1);
          else
            element.translationText = this.sanitizer.sanitize(SecurityContext.HTML, element.translationText);
        }
      }

      let promise: Promise<string>;
      let message: string;

      if (this.isNew) {
        //New custom
        promise = this.sxTranslationService.addCustomVocabulary(this.vocabulary);
        message = "RESOURCE_INTER_ADDED";
      }
      else if (this.isCustom) {
        //Edit custom
        promise = this.sxTranslationService.updateCustomVocabulary(this.vocabulary);
        message = "RESOURCE_INTER_UPDATED";
      }
      else {
        //Edit system
        promise = this.sxTranslationService.updateSystemVocabulary(this.vocabulary);
        message = "RESOURCE_INTER_UPDATED";
      }

      promise.then((res) => {
        if (res) {
          this.alertService.showGrowl({
              type: GrowlType.SUCCESS,
              body: message
          });

          if (this.isNew) {
            this.router.navigate(['../'], { relativeTo: this.aRoute });
          } else {
            this.router.navigate(['../../'], { relativeTo: this.aRoute });
          }            
        } else {
          this.alertService.showGrowl({
              type: GrowlType.DANGER,
              body: "ERROR"
          });
        }
      });
    }
  }

  validar() {
    this.errors = [];

    if (this.isNew) {
      if (!this.vocabulary.code) {
        this.errors['code'] = this.sxTranslationService.getResource("AL_MENOS_1_CARACTER");
        return false;
      }
    }

    return true;
  }

  showAuditInfo() {
    this.auditInfo = !this.auditInfo;
  }

  public back() {
    this.router.navigate(['../'], { relativeTo: this.aRoute.parent });
  }
}


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/resources/detail.resources.component.ts